import api from "../utils/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { API_ENDPOINTS } from "../utils/urls";
import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Menu, X, LogOut, User } from "lucide-react";

const Navbar = () => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleEditProfile = () => {
    navigate("/editProfile");
  };

  const handleLogout = async () => {
    try {
      const res = await api.get(API_ENDPOINTS.LOGOUT);
      console.log(res.data);
      console.log(res.status);
      if (res.status === 200) {
        setAuth("");
        toast.success("Logged Out");
        navigate("/login");
      }
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <nav className="bg-white border-b shadow-md px-4 py-3 rounded-md">
      <div className="flex items-center justify-between">
        {/* Left Section: Toggle + Links */}
        <div className="flex items-center gap-4">
          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden"
            onClick={() => setMobileOpen((prev) => !prev)}
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          {/* Desktop Nav Links */}
          <div className="hidden md:flex gap-6">
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                isActive
                  ? "text-blue-600 font-semibold"
                  : "text-gray-600 hover:text-blue-500"
              }
            >
              Dashboard
            </NavLink>
            <NavLink
              to="/analytics"
              className={({ isActive }) =>
                isActive
                  ? "text-blue-600 font-semibold"
                  : "text-gray-600 hover:text-blue-500"
              }
            >
              Analytics
            </NavLink>
            <NavLink
              to="/inventory"
              className={({ isActive }) =>
                isActive
                  ? "text-blue-600 font-semibold"
                  : "text-gray-600 hover:text-blue-500"
              }
            >
              Inventory
            </NavLink>
            <NavLink
              to="/billing"
              className={({ isActive }) =>
                isActive
                  ? "text-blue-600 font-semibold"
                  : "text-gray-600 hover:text-blue-500"
              }
            >
              Billing
            </NavLink>
            <NavLink
              to="/orders"
              className={({ isActive }) =>
                isActive
                  ? "text-blue-600 font-semibold"
                  : "text-gray-600 hover:text-blue-500"
              }
            >
              Orders
            </NavLink>
          </div>
        </div>

        {/* Right Section: Brand + Profile */}
        <div className="flex items-center gap-4">
          <h1 className="text-xl font-bold text-blue-700">Bill-lex</h1>
          <div className="relative">
            <button
              className="p-2 rounded-full hover:bg-gray-100"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              <User size={20} />
            </button>
            {dropdownOpen && (
              <div className="absolute right-0 mt-2 w-32 bg-white border rounded shadow z-50">
                <button
                  onClick={handleEditProfile}
                  className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Edit Profile
                </button>
                <button
                  onClick={handleLogout}
                  className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <LogOut size={16} className="mr-2" />
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Nav Links */}
      {mobileOpen && (
        <div className="md:hidden mt-3 flex flex-col gap-2">
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              isActive
                ? "text-blue-600 font-semibold"
                : "text-gray-600 hover:text-blue-500"
            }
            onClick={() => setMobileOpen(false)}
          >
            Dashboard
          </NavLink>
          <NavLink
            to="/analytics"
            className={({ isActive }) =>
              isActive
                ? "text-blue-600 font-semibold"
                : "text-gray-600 hover:text-blue-500"
            }
            onClick={() => setMobileOpen(false)}
          >
            Analytics
          </NavLink>
          <NavLink
            to="/inventory"
            className={({ isActive }) =>
              isActive
                ? "text-blue-600 font-semibold"
                : "text-gray-600 hover:text-blue-500"
            }
            onClick={() => setMobileOpen(false)}
          >
            Inventory
          </NavLink>
          <NavLink
            to="/billing"
            className={({ isActive }) =>
              isActive
                ? "text-blue-600 font-semibold"
                : "text-gray-600 hover:text-blue-500"
            }
            onClick={() => setMobileOpen(false)}
          >
            Billing
          </NavLink>
          <NavLink
            to="/orders"
            className={({ isActive }) =>
              isActive
                ? "text-blue-600 font-semibold"
                : "text-gray-600 hover:text-blue-500"
            }
            onClick={() => setMobileOpen(false)}
          >
            Orders
          </NavLink>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
